export const PrivilegeIcon = (props) => {
    const { pClass, spanClass, plan } = props;
    return (
        <div className={props.className}></div>
    );
};